import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Flex, Box, Text } from 'theme-ui';
import CTAButton from '~/components/Generic/CTAButton';

const AppFeatureFooter = ({ ctaButton, extraColumnBody, appLogo }) => {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        gap: '1.2rem',
        alignSelf: 'end',
        pt: ['3rem', 0],
        pb: ['2.4rem', '4.8rem'],
        pl: ['2.4rem', '4rem'],
        pr: ['2.4rem', 0],
      }}
    >
      <Box
        sx={{
          display: ['none', 'block'],
          maxHeight: '6.4rem',
          maxWidth: '6.4rem',
        }}
      >
        <GatsbyImage image={getImage(appLogo)} alt={appLogo.title} objectFit="contain" sx={{ maxHeight: '6.4rem' }} />
      </Box>
      <CTAButton
        baseColor={ctaButton?.baseColor}
        size={ctaButton?.size}
        variant={ctaButton?.variant}
        as="a"
        href={ctaButton?.url}
        forwardSx={{ display: ['block', 'none'] }}
      >
        {ctaButton?.text}
      </CTAButton>
      <Box
        sx={{
          fontSize: '1.2rem',
          fontWeight: 300,
          lineHeight: 1.3,
          textAlign: ['center', 'left'],
          '& > p': { m: 0 },
          '@supports not(flex-gap)': {
            mt: '1.2rem',
          },
        }}
        dangerouslySetInnerHTML={{ __html: extraColumnBody.childMarkdownRemark.html }}
      />
    </Flex>
  );
};

export default AppFeatureFooter;
